const a = {
  addToFolder: () => import("./index.es28.js"),
  addedtoFolder: () => import("./index.es29.js"),
  alarmBell: () => import("./index.es30.js"),
  alignBottom: () => import("./index.es31.js"),
  alignCenter: () => import("./index.es32.js"),
  alignLeft: () => import("./index.es33.js"),
  alignMiddle: () => import("./index.es34.js"),
  alignRight: () => import("./index.es35.js"),
  alignTop: () => import("./index.es36.js"),
  amex: () => import("./index.es37.js"),
  applePay: () => import("./index.es38.js"),
  arrowBack: () => import("./index.es39.js"),
  arrowCursorBlue: () => import("./index.es40.js"),
  arrowCursorPink: () => import("./index.es41.js"),
  arrowCursorYellow: () => import("./index.es42.js"),
  arrowDown: () => import("./index.es43.js"),
  arrowRight: () => import("./index.es44.js"),
  arrowUp: () => import("./index.es45.js"),
  attachment: () => import("./index.es46.js"),
  audioModified: () => import("./index.es47.js"),
  blankCalendarBlue: () => import("./index.es48.js"),
  blankCalendarPink: () => import("./index.es49.js"),
  blankCalendarYellow: () => import("./index.es50.js"),
  businessStartupBlue: () => import("./index.es51.js"),
  businessStartupPink: () => import("./index.es52.js"),
  businessStartupYellow: () => import("./index.es53.js"),
  calendar: () => import("./index.es54.js"),
  cameraBlue: () => import("./index.es55.js"),
  cameraPink: () => import("./index.es56.js"),
  cameraYellow: () => import("./index.es57.js"),
  cameraVideoBlue: () => import("./index.es58.js"),
  cameraVideoPink: () => import("./index.es59.js"),
  cameraVideoYellow: () => import("./index.es60.js"),
  chatBubbleTypingOvalBlue: () => import("./index.es61.js"),
  chatBubbleTypingOvalPink: () => import("./index.es62.js"),
  chatBubbleTypingOvalYellow: () => import("./index.es63.js"),
  chatTwoBubblesSquareBlue: () => import("./index.es64.js"),
  chatTwoBubblesSquarePink: () => import("./index.es65.js"),
  chatTwoBubblesSquareYellow: () => import("./index.es66.js"),
  check: () => import("./index.es67.js"),
  checkCircle: () => import("./index.es68.js"),
  chevronDown: () => import("./index.es69.js"),
  chevronLeft: () => import("./index.es70.js"),
  chevronRight: () => import("./index.es71.js"),
  chevronUp: () => import("./index.es72.js"),
  circleClockBlue: () => import("./index.es73.js"),
  circleClockPink: () => import("./index.es74.js"),
  circleClockYellow: () => import("./index.es75.js"),
  close: () => import("./index.es76.js"),
  cog: () => import("./index.es77.js"),
  compass: () => import("./index.es78.js"),
  controlsForward: () => import("./index.es79.js"),
  controlsPause: () => import("./index.es80.js"),
  controlsPlay: () => import("./index.es81.js"),
  controlsRecord: () => import("./index.es82.js"),
  controlsRewind: () => import("./index.es83.js"),
  controlsStop: () => import("./index.es84.js"),
  dashboardGaugeBlue: () => import("./index.es85.js"),
  dashboardGaugePink: () => import("./index.es86.js"),
  dashboardGaugeYellow: () => import("./index.es87.js"),
  dinersClub: () => import("./index.es88.js"),
  discover: () => import("./index.es89.js"),
  downloadBottom: () => import("./index.es90.js"),
  downloadSquareBlue: () => import("./index.es91.js"),
  downloadSquarePink: () => import("./index.es92.js"),
  downloadSquareYellow: () => import("./index.es93.js"),
  dropbox: () => import("./index.es94.js"),
  emptyClipboardBlue: () => import("./index.es95.js"),
  emptyClipboardPink: () => import("./index.es96.js"),
  emptyClipboardYellow: () => import("./index.es97.js"),
  erlenmeyerFlaskBlue: () => import("./index.es98.js"),
  erlenmeyerFlaskPink: () => import("./index.es99.js"),
  erlenmeyerFlaskYellow: () => import("./index.es100.js"),
  error: () => import("./index.es101.js"),
  expandHorizontal: () => import("./index.es102.js"),
  expandVertical: () => import("./index.es103.js"),
  facebook: () => import("./index.es104.js"),
  favorite: () => import("./index.es105.js"),
  favoriteFilled: () => import("./index.es106.js"),
  fileDouble: () => import("./index.es107.js"),
  filter: () => import("./index.es108.js"),
  filterImage: () => import("./index.es109.js"),
  filterMusic: () => import("./index.es110.js"),
  filterPlus: () => import("./index.es111.js"),
  filterVideo: () => import("./index.es112.js"),
  folderStar: () => import("./index.es113.js"),
  gitHub: () => import("./index.es114.js"),
  googlePay: () => import("./index.es115.js"),
  graphPieChartBlue: () => import("./index.es116.js"),
  graphPieChartPink: () => import("./index.es117.js"),
  graphPieChartYellow: () => import("./index.es118.js"),
  gridRulesBlue: () => import("./index.es119.js"),
  gridRulesPink: () => import("./index.es120.js"),
  gridRulesYellow: () => import("./index.es121.js"),
  happyFaceBlue: () => import("./index.es122.js"),
  happyFacePink: () => import("./index.es123.js"),
  happyFaceYellow: () => import("./index.es124.js"),
  headphonesCustomer: () => import("./index.es125.js"),
  helpChatBlue: () => import("./index.es126.js"),
  helpChatPink: () => import("./index.es127.js"),
  helpChatYellow: () => import("./index.es128.js"),
  homeBlue: () => import("./index.es129.js"),
  homePink: () => import("./index.es130.js"),
  homeYellow: () => import("./index.es131.js"),
  hourGlassBlue: () => import("./index.es132.js"),
  hourGlassPink: () => import("./index.es133.js"),
  hourGlassYellow: () => import("./index.es134.js"),
  house: () => import("./index.es135.js"),
  imageModified: () => import("./index.es136.js"),
  informationCircle: () => import("./index.es137.js"),
  instagram: () => import("./index.es138.js"),
  interfaceAlertAlarmBellBlue: () => import("./index.es139.js"),
  interfaceAlertAlarmBellPink: () => import("./index.es140.js"),
  interfaceAlertAlarmBellYellow: () => import("./index.es141.js"),
  interfaceAwardTrophyBlue: () => import("./index.es142.js"),
  interfaceAwardTrophyPink: () => import("./index.es143.js"),
  interfaceAwardTrophyYellow: () => import("./index.es144.js"),
  interfaceCursorArrowBlue: () => import("./index.es145.js"),
  interfaceCursorArrowPink: () => import("./index.es146.js"),
  interfaceCursorArrowYellow: () => import("./index.es147.js"),
  interfaceFavoriteLikeBlue: () => import("./index.es148.js"),
  interfaceFavoriteLikePink: () => import("./index.es149.js"),
  interfaceFavoriteLikeYellow: () => import("./index.es150.js"),
  interfaceImageVideoAudioSubtitlesBlue: () => import("./index.es151.js"),
  interfaceImageVideoAudioSubtitlesPink: () => import("./index.es152.js"),
  interfaceImageVideoAudioSubtitlesYellow: () => import("./index.es153.js"),
  interfaceLightingLightBulbBlue: () => import("./index.es154.js"),
  interfaceLightingLightBulbPink: () => import("./index.es155.js"),
  interfaceLightingLightBulbYellow: () => import("./index.es156.js"),
  interfaceSearchBlue: () => import("./index.es157.js"),
  interfaceSearchPink: () => import("./index.es158.js"),
  interfaceSearchYellow: () => import("./index.es159.js"),
  keyboardBlue: () => import("./index.es160.js"),
  keyboardPink: () => import("./index.es161.js"),
  keyboardYellow: () => import("./index.es162.js"),
  keyboardArrowRight: () => import("./index.es163.js"),
  layersBlue: () => import("./index.es164.js"),
  layersPink: () => import("./index.es165.js"),
  layersYellow: () => import("./index.es166.js"),
  layoutWindowBlue: () => import("./index.es167.js"),
  layoutWindowPink: () => import("./index.es168.js"),
  layoutWindowYellow: () => import("./index.es169.js"),
  linkedIn: () => import("./index.es170.js"),
  lock: () => import("./index.es171.js"),
  lockUnlock: () => import("./index.es172.js"),
  loginBlue: () => import("./index.es173.js"),
  loginPink: () => import("./index.es174.js"),
  loginYellow: () => import("./index.es175.js"),
  logoStoryblocks: () => import("./index.es176.js"),
  logoStoryblocksGray: () => import("./index.es177.js"),
  logoStoryblocksWhite: () => import("./index.es178.js"),
  maestro: () => import("./index.es179.js"),
  magicWandBlue: () => import("./index.es180.js"),
  magicWandPink: () => import("./index.es181.js"),
  magicWandYellow: () => import("./index.es182.js"),
  maker: () => import("./index.es183.js"),
  mastercard: () => import("./index.es184.js"),
  megaphoneBlue: () => import("./index.es185.js"),
  megaphonePink: () => import("./index.es186.js"),
  megaphoneYellow: () => import("./index.es187.js"),
  microphone: () => import("./index.es188.js"),
  microphoneOff: () => import("./index.es189.js"),
  moneyCashBillBlue: () => import("./index.es190.js"),
  moneyCashBillPink: () => import("./index.es191.js"),
  moneyCashBillYellow: () => import("./index.es192.js"),
  moneyWalletBlue: () => import("./index.es193.js"),
  moneyWalletPink: () => import("./index.es194.js"),
  moneyWalletYellow: () => import("./index.es195.js"),
  musicSound: () => import("./index.es196.js"),
  navigationMenuHorizontal: () => import("./index.es197.js"),
  navigationMenuVertical: () => import("./index.es198.js"),
  newStickyNoteBlue: () => import("./index.es199.js"),
  newStickyNotePink: () => import("./index.es200.js"),
  newStickyNoteYellow: () => import("./index.es201.js"),
  oneFingerTapBlue: () => import("./index.es202.js"),
  oneFingerTapPink: () => import("./index.es203.js"),
  oneFingerTapYellow: () => import("./index.es204.js"),
  openBookBlue: () => import("./index.es205.js"),
  openBookPink: () => import("./index.es206.js"),
  openBookYellow: () => import("./index.es207.js"),
  paragraphLeftAlign: () => import("./index.es208.js"),
  paragraphsCenterAlign: () => import("./index.es209.js"),
  paragraphsRightAlign: () => import("./index.es210.js"),
  payPal: () => import("./index.es211.js"),
  penBlue: () => import("./index.es212.js"),
  penPink: () => import("./index.es213.js"),
  penYellow: () => import("./index.es214.js"),
  pencil: () => import("./index.es215.js"),
  picturesFolderMemoriesBlue: () => import("./index.es216.js"),
  picturesFolderMemoriesPink: () => import("./index.es217.js"),
  picturesFolderMemoriesYellow: () => import("./index.es218.js"),
  pinBlue: () => import("./index.es219.js"),
  pinPink: () => import("./index.es220.js"),
  pinYellow: () => import("./index.es221.js"),
  pinterest: () => import("./index.es222.js"),
  playListBlue: () => import("./index.es223.js"),
  playListPink: () => import("./index.es224.js"),
  playListYellow: () => import("./index.es225.js"),
  playVideo: () => import("./index.es226.js"),
  plus: () => import("./index.es227.js"),
  profileAvatar: () => import("./index.es228.js"),
  questionmark: () => import("./index.es229.js"),
  refresh: () => import("./index.es230.js"),
  screenTvBlue: () => import("./index.es231.js"),
  screenTvPink: () => import("./index.es232.js"),
  screenTvYellow: () => import("./index.es233.js"),
  scriptBlue: () => import("./index.es234.js"),
  scriptPink: () => import("./index.es235.js"),
  scriptYellow: () => import("./index.es236.js"),
  search: () => import("./index.es237.js"),
  searchSimilar: () => import("./index.es238.js"),
  settingMenu: () => import("./index.es239.js"),
  share: () => import("./index.es240.js"),
  shoppingCartBlue: () => import("./index.es241.js"),
  shoppingCartPink: () => import("./index.es242.js"),
  shoppingCartYellow: () => import("./index.es243.js"),
  snapchat: () => import("./index.es244.js"),
  stamp: () => import("./index.es245.js"),
  stopwatchBlue: () => import("./index.es246.js"),
  stopwatchPink: () => import("./index.es247.js"),
  stopwatchYellow: () => import("./index.es248.js"),
  stripe: () => import("./index.es249.js"),
  sunCloudBlue: () => import("./index.es250.js"),
  sunCloudPink: () => import("./index.es251.js"),
  sunCloudYellow: () => import("./index.es252.js"),
  textBold: () => import("./index.es253.js"),
  textInputArea: () => import("./index.es254.js"),
  textItalic: () => import("./index.es255.js"),
  textStrikeThrough: () => import("./index.es256.js"),
  textStyle: () => import("./index.es257.js"),
  textUnderline: () => import("./index.es258.js"),
  thirdEye: () => import("./index.es259.js"),
  trash: () => import("./index.es260.js"),
  travelMapEarthBlue: () => import("./index.es261.js"),
  travelMapEarthPink: () => import("./index.es262.js"),
  travelMapEarthYellow: () => import("./index.es263.js"),
  twitter: () => import("./index.es264.js"),
  uploadBottom: () => import("./index.es265.js"),
  uploadCircleBlue: () => import("./index.es266.js"),
  uploadCirclePink: () => import("./index.es267.js"),
  uploadCircleYellow: () => import("./index.es268.js"),
  userCircleSingleBlue: () => import("./index.es269.js"),
  userCircleSinglePink: () => import("./index.es270.js"),
  userCircleSingleYellow: () => import("./index.es271.js"),
  userSingleBlue: () => import("./index.es272.js"),
  userSinglePink: () => import("./index.es273.js"),
  userSingleYellow: () => import("./index.es274.js"),
  venmo: () => import("./index.es275.js"),
  verticalSliderSquareBlue: () => import("./index.es276.js"),
  verticalSliderSquarePink: () => import("./index.es277.js"),
  verticalSliderSquareYellow: () => import("./index.es278.js"),
  videoEditPeel: () => import("./index.es279.js"),
  videoEditSplit: () => import("./index.es280.js"),
  videoModified: () => import("./index.es281.js"),
  view: () => import("./index.es282.js"),
  viewOff: () => import("./index.es283.js"),
  visa: () => import("./index.es284.js"),
  voiceMailBlue: () => import("./index.es285.js"),
  voiceMailPink: () => import("./index.es286.js"),
  voiceMailYellow: () => import("./index.es287.js"),
  volumeDown: () => import("./index.es288.js"),
  volumeLevelHighBlue: () => import("./index.es289.js"),
  volumeLevelHighPink: () => import("./index.es290.js"),
  volumeLevelHighYellow: () => import("./index.es291.js"),
  volumeMedium: () => import("./index.es292.js"),
  volumeOff: () => import("./index.es293.js"),
  volumeUp: () => import("./index.es294.js"),
  warningTriangle: () => import("./index.es295.js"),
  webcamVideoBlue: () => import("./index.es296.js"),
  webcamVideoPink: () => import("./index.es297.js"),
  webcamVideoYellow: () => import("./index.es298.js"),
  youtube: () => import("./index.es299.js")
}, t = /* @__PURE__ */ new Set([
  "arrowCursor",
  "blankCalendar",
  "businessStartup",
  "camera",
  "cameraVideo",
  "chatBubbleTypingOval",
  "chatTwoBubblesSquare",
  "circleClock",
  "dashboardGauge",
  "downloadSquare",
  "emptyClipboard",
  "erlenmeyerFlask",
  "graphPieChart",
  "gridRules",
  "happyFace",
  "helpChat",
  "home",
  "hourGlass",
  "interfaceAlertAlarmBell",
  "interfaceAwardTrophy",
  "interfaceCursorArrow",
  "interfaceFavoriteLike",
  "interfaceImageVideoAudioSubtitles",
  "interfaceLightingLightBulb",
  "interfaceSearch",
  "keyboard",
  "layers",
  "layoutWindow",
  "login",
  "magicWand",
  "megaphone",
  "moneyCashBill",
  "moneyWallet",
  "newStickyNote",
  "oneFingerTap",
  "openBook",
  "pen",
  "picturesFolderMemories",
  "pin",
  "playList",
  "screenTv",
  "script",
  "shoppingCart",
  "stopwatch",
  "sunCloud",
  "travelMapEarth",
  "uploadCircle",
  "userCircleSingle",
  "userSingle",
  "verticalSliderSquare",
  "voiceMail",
  "volumeLevelHigh",
  "webcamVideo"
]), p = {
  arrowCursor: ["blue", "pink", "yellow"],
  blankCalendar: ["blue", "pink", "yellow"],
  businessStartup: ["blue", "pink", "yellow"],
  camera: ["blue", "pink", "yellow"],
  cameraVideo: ["blue", "pink", "yellow"],
  chatBubbleTypingOval: ["blue", "pink", "yellow"],
  chatTwoBubblesSquare: ["blue", "pink", "yellow"],
  circleClock: ["blue", "pink", "yellow"],
  dashboardGauge: ["blue", "pink", "yellow"],
  downloadSquare: ["blue", "pink", "yellow"],
  emptyClipboard: ["blue", "pink", "yellow"],
  erlenmeyerFlask: ["blue", "pink", "yellow"],
  graphPieChart: ["blue", "pink", "yellow"],
  gridRules: ["blue", "pink", "yellow"],
  happyFace: ["blue", "pink", "yellow"],
  helpChat: ["blue", "pink", "yellow"],
  home: ["blue", "pink", "yellow"],
  hourGlass: ["blue", "pink", "yellow"],
  interfaceAlertAlarmBell: ["blue", "pink", "yellow"],
  interfaceAwardTrophy: ["blue", "pink", "yellow"],
  interfaceCursorArrow: ["blue", "pink", "yellow"],
  interfaceFavoriteLike: ["blue", "pink", "yellow"],
  interfaceImageVideoAudioSubtitles: ["blue", "pink", "yellow"],
  interfaceLightingLightBulb: ["blue", "pink", "yellow"],
  interfaceSearch: ["blue", "pink", "yellow"],
  keyboard: ["blue", "pink", "yellow"],
  layers: ["blue", "pink", "yellow"],
  layoutWindow: ["blue", "pink", "yellow"],
  login: ["blue", "pink", "yellow"],
  magicWand: ["blue", "pink", "yellow"],
  megaphone: ["blue", "pink", "yellow"],
  moneyCashBill: ["blue", "pink", "yellow"],
  moneyWallet: ["blue", "pink", "yellow"],
  newStickyNote: ["blue", "pink", "yellow"],
  oneFingerTap: ["blue", "pink", "yellow"],
  openBook: ["blue", "pink", "yellow"],
  pen: ["blue", "pink", "yellow"],
  picturesFolderMemories: ["blue", "pink", "yellow"],
  pin: ["blue", "pink", "yellow"],
  playList: ["blue", "pink", "yellow"],
  screenTv: ["blue", "pink", "yellow"],
  script: ["blue", "pink", "yellow"],
  shoppingCart: ["blue", "pink", "yellow"],
  stopwatch: ["blue", "pink", "yellow"],
  sunCloud: ["blue", "pink", "yellow"],
  travelMapEarth: ["blue", "pink", "yellow"],
  uploadCircle: ["blue", "pink", "yellow"],
  userCircleSingle: ["blue", "pink", "yellow"],
  userSingle: ["blue", "pink", "yellow"],
  verticalSliderSquare: ["blue", "pink", "yellow"],
  voiceMail: ["blue", "pink", "yellow"],
  volumeLevelHigh: ["blue", "pink", "yellow"],
  webcamVideo: ["blue", "pink", "yellow"]
};
function m(e, o) {
  let r = e;
  if (t.has(e)) {
    const i = p[e] || [], l = o || i[0];
    if (o && !i.includes(o))
      return console.error(
        'Invalid variant "' + o + '" for icon "' + e + '". Available variants: ' + i.join(", ")
      ), null;
    r = e + l.charAt(0).toUpperCase() + l.slice(1);
  } else o && console.warn('Icon "' + e + '" does not support variants. Ignoring variant "' + o + '".');
  return a[r] || null;
}
function n(e) {
  return t.has(e);
}
function u(e) {
  const o = p[e];
  return o ? o[0] : void 0;
}
export {
  u as getDefaultVariant,
  m as getIconImport,
  n as hasVariants
};
